import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage, Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {AnalyticsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import noResults from '../../../assets/images/noResults.png';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {removePanelAction} from '../../../store/panels/panelsActions';
import {AnalyticsInfoState} from '../reportElements/analyticsInfoState';

/*
 * Props.
 */

interface LiveDashboardOtherPoppedOutMessage {
  poppedOutPanelId: AnalyticsPanelId;
}

/*
 * Styles.
 */

const StyledOtherPoppedOutMessageWrapperDiv = styled.div`
  background-color: ${(p) => p.theme.greys.shade20};
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledBodyDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

/*
 * Component.
 */

export const LiveDashboardOtherPoppedOutMessage: FC<LiveDashboardOtherPoppedOutMessage> = ({
  poppedOutPanelId,
}) => {
  const dispatch = useAppDispatch();
  const localize = useLocalize();

  const title = localize(
    defineMessage({
      id: 'live-dashboard-other-popped-out-title',
      message: 'Already opened in external window',
    }),
  );

  return (
    <StyledOtherPoppedOutMessageWrapperDiv>
      <AnalyticsInfoState
        imgWidth={92}
        imgHeight={67}
        imgPath={noResults}
        title={title}
        body={
          <StyledBodyDiv>
            <Trans id="live-dashboard-other-popped-out-message">
              The live dashboard is open in an external window, and can&apos;t be viewed in more than one
              window.
            </Trans>
            <Button
              variant={ButtonVariantsEnum.SECONDARY}
              onClick={() => dispatch(removePanelAction(poppedOutPanelId))}
              // TODO(ldemarne): Use popinSmall when it exists.
              rightIcon="popin"
            >
              <Trans id="live-dashboard-other-popped-out-cta">Open here instead</Trans>
            </Button>
          </StyledBodyDiv>
        }
      />
    </StyledOtherPoppedOutMessageWrapperDiv>
  );
};
